import type { Node } from '../../../core/models/scene';

/**
 * The neutral "required for connectivity, not a match" treatment for a
 * reporting-chain context node — shared by every renderer that needs it
 * (the editor's live view rules, the read-only /ov viewer, and server-side
 * export), so a required manager can never look like it matched a saved
 * view's or department view's filter, no matter where it's rendered.
 */
export const CHAIN_OPACITY = 0.55;
export const CHAIN_BACKGROUND_COLOR = '#F3F4F6';
export const CHAIN_BORDER_COLOR = '#9CA3AF';
export const CHAIN_TEXT_COLOR = '#4B5563';

/**
 * True when `buildPeopleChartScene` baked this node in only to keep the
 * reporting chain connected (a department view's or saved view's required
 * manager ancestor) — never a scope-rule match itself.
 */
export function isReportingChainContextNode(
  node: Pick<Node, 'attrs'> | null | undefined,
): boolean {
  return (node?.attrs as { projectionContext?: string } | undefined)?.projectionContext === 'reporting_chain';
}

export interface ReportingChainDimStyle {
  readonly opacity: number;
  readonly backgroundColor: string;
  readonly borderColor: string;
  readonly textColor: string;
}

/** The flat dim style values a reporting-chain context node always gets. */
export function reportingChainDimStyle(): ReportingChainDimStyle {
  return {
    opacity: CHAIN_OPACITY,
    backgroundColor: CHAIN_BACKGROUND_COLOR,
    borderColor: CHAIN_BORDER_COLOR,
    textColor: CHAIN_TEXT_COLOR,
  };
}
